import "./SeemaNavButton.scss";
import { useContext, type FC } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import classNames from "classnames";
import { useIcon } from "@SeemplicityDev/shared";
import { ChatStreamContext } from "../../../SeemChat/Provider/ChatStreamProvider";

interface SeemaNavButtonProps {
  to: string;
}

const SeemaNavButton: FC<SeemaNavButtonProps> = ({ to }) => {
  const { getSvg } = useIcon();
  const {
    streamState: { isStreaming },
  } = useContext(ChatStreamContext);
  const isActive = !!useRouteMatch(to);

  return (
    <Link
      to={to}
      className={classNames("top-menu-seema", { "is-active": isActive })}
      data-testid="selection-menu-Seema"
      aria-label={isStreaming ? "Seema is responding" : "Seema"}
      aria-current={isActive ? "page" : undefined}
    >
      {isStreaming ? (
        <img className="top-menu-seema-star" src={getSvg("icon-ai")} alt="" />
      ) : (
        <img
          className="top-menu-seema-avatar"
          src={getSvg("seema-ai")}
          alt=""
        />
      )}
    </Link>
  );
};

export default SeemaNavButton;
